import { createSelector } from '@ngrx/store';
import { LayoutState } from './layout.state';
import { selectLayoutState } from '../core/core.state';

export const selectLayout = createSelector(
  selectLayoutState,
  (state: LayoutState) => state
);

export const selectTotalScreenSize = createSelector(
  selectLayout,
  (state: LayoutState) => state.totalScreenSize
);

export const selectTotalWindowHeight = createSelector(
  selectLayout,
  (state: LayoutState) => state.totalWindowHeight
);

export const selectTotalWindowWidth = createSelector(
  selectLayout,
  (state: LayoutState) => state.totalWindowWidth
);

export const selectViewPortScreenSize = createSelector(
  selectLayout,
  (state: LayoutState) => state.totalWindowWidth - (state.sidenavOpened ? 250 : 0) - state.popoverWidth
);

export const selectSidenavOpened = createSelector(
  selectLayout,
  (state: LayoutState) => state.sidenavOpened
);

export const selectPopoverWidth = createSelector(
  selectLayout,
  (state: LayoutState) => state.popoverWidth
);

export const selectPopoverDocked = createSelector(
  selectLayout,
  (state: LayoutState) => state.popoverDocked
);

export const selectToolbarZindex = createSelector(
  selectLayout,
  (state: LayoutState) => state.toolbarZindex
);

export const selectGlobalReference = createSelector(
  selectLayout,
  (state: LayoutState) => state.globalReference
);